import React, {useEffect, useRef, useState} from 'react';
import GenericDialog from '../../common/GenericDialog';
import MathJaxHTMLContent from '../../common/MathJaxHTMLContent';
import axios from "../../common/axios";

const PreviewTestDialog = ({
                               open,
                               onClose,
                               testId = null,
                               title = 'Preview Test'
                           }) => {

    const [viewTestLoading, setViewTestLoading] = useState(true),
        [viewTestContent, setViewTestContent] = useState('');

    const handleViewTest = () => {
        if (testId !== null) {
            axios.get('/controlCentre/showTestPreview.action', {
                params: {
                    testId: testId
                }
            }).then(response => {
                if (response.data) {
                    setViewTestContent(response.data);
                }
            }).catch((error) => {
                console.error('Error getting test to preview: ', error);
            }).finally(() => {
                setViewTestLoading(false);
            });
        }
    }

    useEffect(()=>{
        handleViewTest();
    },[testId])

    return (
        <GenericDialog
            title={title}
            open={open}
            fullWidth={true}
            isLoading={viewTestLoading}
            onClose={onClose}
            buttons={[
                { name: 'Close' },
            ]}
        >
            <MathJaxHTMLContent disableInputs={true} html={viewTestContent} />
        </GenericDialog>
    );
};

export default PreviewTestDialog;
